// extracted by mini-css-extract-plugin
export default {"botones":"inicio_botones__U3BZt","slideUp":"inicio_slideUp__Z8eDZ","perfilInicio":"inicio_perfilInicio__qKZxk"};